export const isBrowser = typeof window !== "undefined";

export const safeRedirect = (path) => {
  if (!isBrowser) {
    return;
  }

  window.location.href = path;
};
